<section class="hero-content " >
          
    <div class="row">
        <div class="col-md-12 col-lg-5">
            <div class="hero-title">

                <h1>
                    <span>C</span> <img src="assets/images/logo/Coin.svg" alt="logo"><span>IN</span>
                </h1>

                <h2 class="sub-title">
                    Curiosity
                </h2>
                <p class="title-des">
                    Eye Appeal Assessed By You
                </p>
            </div>

        </div>
        <div class="col-md-12 col-lg-7">
            <div class="banner-cta">
                <div class="banner-cta-overlay"> </div>
                <div class="banner-cta-des">
                    <p>In Numismatics (Coin Collecting) the most subjective element in grading is Eye
                        Appeal, the overall look of a coin. The value of a collector's coin is significantly
                        attributed to its eye appeal. When you join Coin Curiosity, you can assess and
                        assign grades to members' coins. Make an impact with your eyes! </p>

                    <div class="cta-video__play">
                     
                        <div class="video-play__icon">
                            <img src="assets/images/icons/icon.png" class="img-fluid" alt="video play icon">
                        </div>
                        <div class="video-play__text clickable-text " (click)="scrollToPackageSection()">
                            <p><a> Let’s get started!</a></p>
                        </div>
                       

                    </div>
                </div>

            </div>

        </div>
    </div>


</section>